const getPropertyFromUrl = () => {
    const urlParams = decodeURIComponent(window.location.pathname).split('/');
    if (urlParams.includes('hotels') || urlParams.includes('luxury-hotels') || urlParams.includes('hotel-search')) {
        return 'Properties_Hotel';
    }
    if (urlParams.includes('villas') || urlParams.includes('luxury-villas')) {
        return ['Properties_Villa', 'Properties_HotelRoomVilla'];
    }
    return 'all';
};

export { getPropertyFromUrl };
